'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';
import StaticModal from "./static-modal";
import UrlModal from "./url-modal";

export default class ModalComponent extends Component {
    constructor(el) {
        super(el);
        this.$container = $(this.container);
        this.modalInstance = null;
        this.init();
    }

    init() {
        this.refresh = this.$container.data('modal-refresh') || false;
        this.$container.on('click', (e) => {
            this.handleClick(e);
        })
    }

    handleClick(e) {
        e.preventDefault();

        if (this.modalInstance === null) {
            let targetSelector = this.$container.data('modal-target');
            if (targetSelector) {
                this.modalInstance = new StaticModal(targetSelector);
            }

            let href = this.$container.attr('href');
            if (href) {
                this.modalInstance = new UrlModal(href);
            }
        }

        if (this.modalInstance) {
            this.modalInstance.open(this.refresh);
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/modal/js/generic.modal.js